import spriteManifest from '../../game/spriteManifest.json'
import { assetUrl } from '../runnerPreview/previewLayout'
import type { RunnerSlot } from '../runnerPreview/roster'

type Obj = Record<string, unknown>

const obj = (v: unknown): Obj =>
  typeof v === 'object' && v !== null && !Array.isArray(v) ? (v as Obj) : {}

/**
 * URL of a UI image from the sprite manifest's `art.default.src` (docs/art/PHASE3_ART.md: code
 * takes the file from the manifest), or null when the art is not delivered (CSS placeholder).
 */
export function uiArt(kind: string, manifest: unknown = spriteManifest): string | null {
  const src = obj(obj(obj(obj(manifest)[kind]).art).default).src
  return typeof src === 'string' && src !== '' ? assetUrl(src) : null
}

/** Pedestal tints by seat index: mint, sky, violet, coral (the cast colours, STYLE.md). */
export const SEAT_TINTS: readonly string[] = ['#4fe3b5', '#7fd3ff', '#9b7bff', '#ff6b6b']

/** The runner to stand on a pedestal: the seat's `charId`, else a coloured placeholder box. */
export function seatRunner(runners: readonly RunnerSlot[], charId: number): RunnerSlot {
  return (
    runners.find((r) => r.charId === charId) ?? {
      charId,
      kind: `player_${charId}`,
      name: null,
      color: SEAT_TINTS[charId % SEAT_TINTS.length] ?? '#8a97ad',
      rig: null,
      image: null,
      ready: false,
    }
  )
}
